import React from 'react';
import { ToolbarIconButton } from './ToolbarIconButton';
import { PageToolbarProps } from './types';
import { translate } from 'javascripts/translations/i18n';

export default function GalleryMenu(props: PageToolbarProps) {
  const { onChooseGalleryPhoto, disabled } = props;

  return onChooseGalleryPhoto ? (
    <ToolbarIconButton
      icon="image-plus-outline"
      accessibilityLabel={translate('pages.toolbar.addImage')}
      onClick={onChooseGalleryPhoto}
      disabled={disabled}
    />
  ) : null;
}
